<template>
  <div class="container">
    <h1>杨文熠的WebRTC</h1>
    <input v-model="username" type="text" placeholder="填写姓名,将作为连接服务器唯一标识" />
    <button @click="submit">Login</button>
    
    <div class="version">
      <p>版本：1.0.0</p>
      <p>PC端测试通过、移动端安卓微信内置浏览器测试通过</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
const username = ref('');
const router = useRouter();
const submit = () => {
  if (username.value.trim()) {
    localStorage.setItem('username', username.value);
      console.log("尝试跳转")
      router.push('/ChatView');
    } else {
      alert('请输入姓名');
    }
};


</script>

<style lang="scss" scoped>
.container {
  height: 100%;
    display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.version{
  position: fixed;
  text-align: right;
  bottom: 20px;
  right: 20px;
}
h1 {
  color: #333;
  margin-bottom: 20px;
}

input {
  padding: 15px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  width: 300px;
  transition: all 0.3s ease;
}

input:focus {
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transform: scale(1.02);
}

button {
  padding: 15px 30px;
  margin-top: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
}

button:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

</style>
  